export const PURCHASE_BAR_VISIBLITY_CLASS = 'third-party-buttons__purchase-bar-visible';
export const SIDE_BAR_VISIBLITY_CLASS = 'third-party-buttons__side-bar-visible';
export const FULL_PAGE_GALLERY_VISIBLE = 'third-party-buttons__full-page-gallery-visible';
export const COOKIE_BANNER_IS_VISIBLE = 'third-party-buttons__cookie-banner--visible';
